import { Component, computed, effect, input, InputSignal, output, signal, WritableSignal } from '@angular/core';

@Component({
    selector: 'app-urgent-button',
    templateUrl: './urgent-button.component.html',
    imports: []
})
export class UrgentButtonComponent {
    public urgent: InputSignal<boolean> = input(false);
    public disabled: InputSignal<boolean> = input(false);
    // eslint-disable-next-line @angular-eslint/no-output-native
    public change = output<boolean>();

    protected internalUrgent: WritableSignal<boolean> = signal(false);
    protected hovered: WritableSignal<boolean> = signal(false);
    private addedTimout: WritableSignal<boolean> = signal(false);
    private removedTimout: WritableSignal<boolean> = signal(false);

    constructor() {
        effect(() => {
            if (this.urgent() !== this.internalUrgent()) {
                this.internalUrgent.set(this.urgent());
            }
        });
    }

    public icon = computed(() => {
        if (this.disabled()) {
            return this.internalUrgent() ? 'bookmark_filled' : 'bookmark';
        }

        if (this.internalUrgent() && this.addedTimout()) {
            return 'bookmark_added';
        }

        if (this.internalUrgent() && this.hovered()) {
            return 'bookmark_remove';
        }

        if (!this.internalUrgent() && this.removedTimout()) {
            return 'bookmark_remove';
        }

        if (!this.internalUrgent() && this.hovered()) {
            return 'bookmark_add';
        }

        return this.internalUrgent() ? 'bookmark_filled' : 'bookmark';
    });

    public onMouseEnter(): void {
        this.hovered.set(true);
    }

    public onMouseLeave(): void {
        this.hovered.set(false);
    }

    public toggleUrgent(): void {
        if (this.disabled()) {
            return;
        }

        this.internalUrgent.set(!this.internalUrgent());

        if (this.internalUrgent()) {
            this.addedTimout.set(true);
            this.removedTimout.set(false);
            setTimeout(() => {
                this.addedTimout.set(false);
            }, 2000);
        } else {
            this.addedTimout.set(false);
            this.removedTimout.set(true);
            setTimeout(() => {
                this.removedTimout.set(false);
            }, 2000);
        }

        this.change.emit(this.internalUrgent());
    }
}
